<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.state" @tab-click="handleFilter">
          <el-tab-pane label="所有商家" name="-1" />
          <el-tab-pane label="未审核" name="0" />
          <el-tab-pane label="审核通过" name="1" />
          <el-tab-pane label="审核失败" name="2" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.keyword" class="filter-item" placeholder="商家名称" clearable />
          </el-col>
          <el-col :xs="24" :sm="3">
            <el-select v-model="queryParams.status" class="filter-item" placeholder="系统状态" clearable>
              <el-option label="禁用" :value="0" />
              <el-option label="启用" :value="1" />
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="9">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">增加商家</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell" />
        <el-table-column label="商家名称" prop="shopName" min-width="150" />
        <el-table-column label="所属地区" prop="regionName" width="200" />
        <el-table-column label="详细地址" prop="address" min-width="150" />
        <el-table-column label="优惠折扣" prop="discount" width="80" align="right" />
        <el-table-column label="排序" prop="sortBy" width="80" align="center" />
        <el-table-column label="推荐人" prop="inviterName" width="150" />
        <el-table-column label="推荐码" prop="inviteCode" width="80" />
        <el-table-column label="创建时间" prop="createTime" width="150" />
        <el-table-column label="系统状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>"
        </el-table-column>
        <el-table-column label="审核状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.auditState | checkType" effect="dark">{{ row.auditState | checkText }}</el-tag>
            <el-tooltip v-if="row.auditState === 2 && row.auditComment" :content="row.auditComment" placement="bottom" effect="light">
              <i class="tool-tip-icon el-icon-warning-outline" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="scope.row.auditState !== 0" @click.native.stop="handleApprove(scope.row)"><i class="el-icon-check" /> 商家审核</el-dropdown-item>
                <el-dropdown-item divided @click.native.stop="handleDetail(scope.row)"><i class="el-icon-more" /> 商家详情</el-dropdown-item>
                <el-dropdown-item @click.native.stop="handleEdit(scope.row)"><i class="el-icon-edit" /> 编辑商家</el-dropdown-item>
                <el-dropdown-item @click.native.stop="handleRemove(scope.row, scope.$index)"><i class="el-icon-delete" /> 删除商家</el-dropdown-item>
                <el-dropdown-item @click.native.stop="handleReset(scope.row)"><i class="el-icon-refresh" /> 重置密码</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.auditState !== 1 || scope.row.status !== 1" divided @click.native.stop="handleGoods(scope.row)"><i class="el-icon-goods" /> 商品列表</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.auditState !== 1 || scope.row.status !== 1" @click.native.stop="handleNewGoods(scope.row)"><i class="el-icon-present" /> 添加商品</el-dropdown-item>
                <el-dropdown-item :disabled="scope.row.auditState !== 1 || scope.row.status !== 1" divided @click.native.stop="handleEmployee(scope.row)"><i class="el-icon-user" /> 店员管理</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <el-dialog
      v-loading="approveLoading"
      title="商家审核"
      width="80%"
      top="5vh"
      destroy-on-close
      custom-class="dialog-scrollbar"
      :visible.sync="dialogVisible"
      :fullscreen="device==='mobile'"
    >
      <store-review :store-id="storeId" :can-edit="false" />
      <template v-slot:footer>
        <el-button style="margin-right:10px" @click.stop="dialogVisible = false">取 消</el-button>
        <el-popover v-model="approveVisible" title="审核不通过" placement="top" @hide="approveMessage = ''">
          <p><el-input v-model="approveMessage" placeholder="请输入不通过的理由" clearable /></p>
          <div class="flex align-center just-end">
            <el-button type="text" size="medium" @click.stop="approveVisible = false">取消</el-button>
            <el-button type="primary" @click.stop="onApproved(2)">确定</el-button>
          </div>
          <el-button slot="reference" type="info">不通过</el-button>
        </el-popover>
        <el-button type="primary" style="margin-left:10px" @click.stop="onApproved(1)">审核通过</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getStorePages, approveStore, updateStatus, removeStore, resetPassword } from '@/api/store'

export default {
  name: 'StoreList',
  components: {
    Pagination: () => import('@/components/Pagination'),
    StoreReview: () => import('./review')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  filters: {
    checkType(index) {
      const tag = ['', 'success', 'info']
      return tag[index]
    },
    checkText(index) {
      const tag = ['未审核', '审核通过', '审核失败']
      return tag[index]
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryParams: {
        page: 1,
        limit: 20,
        keyword: '',
        status: '',
        state: '-1'
      },
      storeId: '',
      dialogVisible: false,
      approveVisible: false,
      approveMessage: '',
      approveLoading: false,
      onsaleVisible: false
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.queryParams, {
        state: this.queryParams.state === '-1' ? undefined : this.queryParams.state
      })
      getStorePages(params).then(response => {
        this.list = response.records
        this.total = response.total
      }).finally(() => {
        this.$util.delay(500).then(() => {
          this.loading = false
        })
      })
    },
    handleFilter() {
      this.fetchData()
    },
    handleCreate() {
      this.$router.push({ path: `/store/detail`, query: { action: 'create' }})
    },
    handleApprove(item) {
      this.storeId = item.id
      this.dialogVisible = true
    },
    onApproved(status) {
      const approveData = {
        id: this.storeId,
        auditState: status,
        auditComment: this.approveMessage
      }
      this.approveLoading = true
      approveStore(approveData).then(() => {
        this.approveMessage = ''
        return this.$util.delay()
      }).then(() => {
        const item = this.list.filter(value => value.id === this.storeId)
        if (item && item.length) {
          item[0].auditComment = approveData.auditComment
          item[0].auditState = status
          if (status !== 1) item[0].status = 0
        }
        this.dialogVisible = false
      }).catch(() => {
        this.$message.error('提交审核数据失败')
      }).finally(() => {
        this.approveLoading = false
      })
    },
    handleDetail(item) {
      this.$router.push({ path: `/store/detail`, query: { action: 'view', id: `${item.id}` }})
    },
    handleEdit(item) {
      this.$router.push({ path: `/store/detail`, query: { action: 'edit', id: `${item.id}` }})
    },
    handleRemove(item, index) {
      this.$confirm('您确认要删除该商家吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeStore(item).then(() => {
          this.$message.success('商家删除成功')
          this.$util.delay().then(() => {
            this.list.splice(index, 1)
          })
        })
      }).catch(() => {})
    },
    async handleUpdate(item) {
      await updateStatus(item)
    },
    handleReset(item) {
      this.$confirm('您确认要重置该商家的登录密码吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetPassword(item).then(() => {
          this.$message.success('商家密码已经重置为：123456')
        })
      }).catch(() => {})
    },
    handleGoods(item) {
      this.$router.push({ path: `/store/goods/index`, query: { storeId: `${item.id}` }})
    },
    handleNewGoods(item) {
      this.$router.push({ path: `/store/goods/detail`, query: { action: 'create', from: 'store', storeId: `${item.id}` }})
    },
    handleEmployee(item) {
      this.$router.push({ path: `/store/employee`, query: { shopId: `${item.id}` }})
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-card__header {
      padding-bottom: 0;
    }
  }
  .max-width-input {
    width: 150px;
    max-width: 100%;
  }
  .tool-tip-icon {
    margin-left: 5px;
    font-size: 14px;
    color: #E6A23C;
    font-weight: 600;
    cursor: default;
  }
</style>
